/**
 * Direktive zum Initialisieren und Aufräumen von Benutzeraktionen
 * @class directive_v3sInteraction
 * @memberOf v3sWbtPlayerApp:animation
 * @requires {@link v3sWbtPlayerApp:animation.service_v3sInteractionService}
 */
angular.module('v3sWbtPlayerApp').directive('v3sInteraction', ["v3sInteractionService", function (v3sInteractionService) {
    return {
        restrict: 'E',
        controller: ["$scope", function ($scope) {
            v3sInteractionService.init();

            $scope.$on('$destroy', function () {
                v3sInteractionService.destroy();
            });
        }]
    }
}]);